import { cva } from '@scatterlab/zeta-core';

export const button = cva(
  'flex min-w-max flex-row items-center justify-center rounded-6 font-medium text-white transition-colors disabled:cursor-not-allowed disabled:bg-gray-900 disabled:text-gray-600',
  {
    variants: {
      variant: {
        primary: 'bg-primary-400 hover:bg-primary-500 active:bg-primary-500',
        secondary: 'bg-gray-800 hover:bg-gray-900 active:bg-gray-900',
      },
      size: {
        small: 'body14 h-[32px] px-3',
        medium: 'body14 h-[40px] px-4',
        large: 'body16 h-[48px] px-4',
      },
      hasRightIcon: {
        true: 'gap-[2px]',
      },
      hasLeftIcon: {
        true: 'gap-1',
      },
    },
    compoundVariants: [
      {
        size: 'small',
        hasRightIcon: true,
        class: 'pl-4 pr-[14px]',
      },
      {
        size: 'small',
        hasLeftIcon: true,
        class: 'pl-2.5 pr-3',
      },
      {
        size: 'large',
        hasRightIcon: true,
        class: 'pl-5 pr-[18px]',
      },
    ],
    defaultVariants: {
      variant: 'primary',
      size: 'small',
      hasRightIcon: false,
    },
  },
);

// eslint-disable-next-line tailwindcss/enforces-shorthand
export const floatingButton = cva(
  'group z-10 flex h-12 w-12 min-w-max flex-row items-center justify-center rounded-full py-1 transition-colors disabled:cursor-not-allowed disabled:border disabled:border-white/5 disabled:bg-gray-800 group-disabled:text-white/20',
  {
    variants: {
      variant: {
        primary:
          'bg-primary-400 text-white hover:bg-primary-500 active:bg-primary-500',
        secondary:
          'border-white/5 bg-gray-200 text-gray-600 hover:bg-gray-400 active:bg-gray-400',
      },
    },
    defaultVariants: {
      variant: 'primary',
    },
  },
);

export const textField = cva(
  'android:py-1.5 native:transition-none body14 flex resize-none flex-row items-center justify-between gap-2 rounded-lg border border-white/[8%] bg-white/5 p-3 !text-white caret-primary-300 transition-colors placeholder:text-white/50 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400',
  {
    variants: {
      textarea: {
        true: 'outline-none',
      },
      focus: {
        true: '!border-primary-300 !bg-gray-main',
      },
    },
    defaultVariants: {
      textarea: false,
      focus: false,
    },
  },
);

export const chip = cva(
  'body14 flex min-w-max max-w-min flex-row items-center rounded-[18px] text-white transition-colors',
  {
    variants: {
      variant: {
        primary: 'bg-primary-400 active:bg-primary-500',
        secondary: 'bg-gray-800 active:bg-gray-900',
        outline: 'border border-white/[16%] active:bg-white/[8%]',
      },
      hasIcon: {
        true: 'py-1 pl-3 pr-1',
        false: 'px-3 py-1.5',
      },
    },
    defaultVariants: {
      variant: 'secondary',
      hasIcon: false,
    },
  },
);

export const tabBarItem = cva(
  'native:[container:none] cursor-pointer transition-colors',
  {
    variants: {
      active: {
        true: 'native:border-primary-400 border-b-primary-400 text-white',
        false: 'border-b-transparent text-white/50',
      },
      size: {
        sm: 'body14 border-b-2 pb-1 font-medium',
        md: 'title18 border-b-2 pb-1.5',
        full: 'body14 flex h-[47px] w-full flex-row items-center justify-center border-b-2 font-medium',
      },
    },
    compoundVariants: [
      {
        active: false,
        size: 'full',
        class: 'border-b border-b-white/[8%]',
      },
    ],
    defaultVariants: {
      active: false,
      size: 'md',
    },
  },
);
